module.exports = __webpack_public_path__ + "static/media/poster1.9980fc2c.png";